import Route from '@ember/routing/route';

export default class HotelWizardsPreferredRateOnboardingMealTypeRoute extends Route {
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/require-await
  async model() {
    return this.modelFor('hotel.wizards.preferred-rate-onboarding');
  }
}
